module.exports = __webpack_public_path__ + "img/03.dab42c71.jpg";